import { render, staticRenderFns } from "./WorkspaceHistoryTab.vue?vue&type=template&id=cd402eb2&scoped=true"
import script from "./WorkspaceHistoryTab.vue?vue&type=script&lang=js"
export * from "./WorkspaceHistoryTab.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceHistoryTab.vue?vue&type=style&index=0&id=cd402eb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd402eb2",
  null
  
)

export default component.exports